import { IAffiliateListTableLang } from '../../../types/lang'

export const affiliateListTableLang: IAffiliateListTableLang = {
	affiliate_list_table: {
		column_id: 'ID_ua',
		column_name: 'Name_ua',
		column_percent: 'Percent, %_ua',
		column_notes: 'Notes_ua'
	}
}